import {
  VENDORS_ALL,
  VENDORS_ALL_SUCCESS,
  VENDORS_CREATE,
  VENDORS_CREATE_SUCCESS,
  VENDORS_DELETE,
  VENDORS_DELETE_SUCCESS,
  VENDORS_GET,
  VENDORS_GET_SUCCESS,
  VENDORS_UPDATE,
  VENDORS_UPDATE_PAGINATION,
  VENDORS_UPDATE_SUCCESS,
} from '../constants/Vendors';

const initialState = {
  vendor: {
    id: null,
    name: '',
    color: '',
  },
  vendors: null,
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
  loading: false,
};

const vendors = (state = initialState, action) => {
  switch (action.type) {
    case VENDORS_ALL:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case VENDORS_ALL_SUCCESS:
      return {
        ...state,
        vendors: action.vendors,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case VENDORS_GET:
      return {
        ...state,
        loading: true,
      };
    case VENDORS_GET_SUCCESS:
      return {
        ...state,
        vendor: action.vendor,
        loading: false,
      };
    case VENDORS_CREATE:
      return {
        ...state,
        loading: true,
      };
    case VENDORS_CREATE_SUCCESS:
      return {
        ...state,
        vendors: [...(state.vendors ? state.vendors : []), action.vendor],
        loading: false,
      };
    case VENDORS_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case VENDORS_UPDATE_SUCCESS:
      return {
        ...state,
        vendor: action.vendor,
        vendors:
          state.vendors &&
          state.vendors.map((t) => {
            if (action.vendor.id === t.id) {
              return action.vendor;
            }
            return t;
          }),
        loading: false,
      };
    case VENDORS_UPDATE_PAGINATION:
      return {
        ...state,
        perPage: action.perPage,
        page: action.page,
      };
    case VENDORS_DELETE:
      return {
        ...state,
        loading: true,
      };
    case VENDORS_DELETE_SUCCESS:
      return {
        ...state,
        vendors: state.vendors
          ? state.vendors.filter((t) => t.id !== action.id)
          : [],
        loading: false,
      };
    default:
      return state;
  }
};

export default vendors;
